export function saveDocScrollPosition(docId,scrollTop) {
	return (dispatch) => {
		dispatch({ type: 'SET_DOC_SCROLL_POSITION',docId:docId,scrollTop:scrollTop })
	
		}
}
